import { useIsMobileViewport } from '@/hooks/useIsMobileViewport';

export type OverlayPresentation = 'sheet' | 'dialog' | 'fullscreen' | 'popover';

export interface OverlayPresentationResult {
  /** User-requested presentation mode. */
  presentation: OverlayPresentation;
  /** True when viewport is below 768px. */
  isMobileViewport: boolean;
  /** Bottom sheet on mobile when presentation is sheet; centered dialog otherwise. */
  useMobileSheet: boolean;
  /** Centered dialog layout (desktop sheet mode, dialog mode, or mobile dialog exception). */
  useCenteredDialog: boolean;
  /** Full viewport panel. */
  useFullscreen: boolean;
  /** Anchored popover (caller positions children). */
  usePopover: boolean;
}

/**
 * Resolves overlay shell layout from presentation + viewport (<768px = mobile sheet).
 */
export function useOverlayPresentation(
  presentation: OverlayPresentation = 'sheet',
): OverlayPresentationResult {
  const isMobileViewport = useIsMobileViewport();

  const useMobileSheet =
    presentation === 'sheet' && isMobileViewport;
  const useCenteredDialog =
    presentation === 'dialog' ||
    (presentation === 'sheet' && !isMobileViewport);
  const useFullscreen = presentation === 'fullscreen';
  const usePopover = presentation === 'popover';

  return {
    presentation,
    isMobileViewport,
    useMobileSheet,
    useCenteredDialog,
    useFullscreen,
    usePopover,
  };
}
